import React, { useState, useEffect } from "react";
import ReportsPage from "../../../../entities/DashboardPage/HRModule/Reports";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../utils/blobError";

const Reports = () => {
  const [permission, setPermission] = useState(null);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const [departmentData, setDepartmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const [deductionType, setDeductionType] = useState([]);
  const [pensionType, setPensionType] = useState([]);
  const [leviesType, setLeviesType] = useState([]);
  const [fringeData, setFringeData] = useState([]);
  const [empData, setempData] = useState([]);
  const [creditsType, setCreditsType] = useState([]);
  const [reportMenu, setReportMenu] = useState([]);
  const [payeName, setPayeName] = useState("");
  const { showAlert } = useAlert();

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getDepartment();
      getDeductionType();
      getPensionType();
      getLeviesType();
      getFringeType();
      getAllDepartmentList();
      getReportMenu();
      getPayeName();
    }
  }, [permission])

  useEffect(() => {
    getAllDepartmentList();
    getCreditsType();

  }, [])

  const getCreditsType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCreditsType();
      if (result?.success) {
        setCreditsType(result?.data?.credits);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const getAllDepartmentList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllDepartmentList();
      if (result?.success) {
        setempData(result?.data);

        LoaderHelper.loaderStatus(false);

      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  // The tax is called something different in some countries; the company's configured name is used on the reports.
  const getPayeName = async () => {
    try {
      const result = await AuthService.getPayslipSetting();
      const settings = Array.isArray(result?.data) ? result?.data[0] : result?.data;
      if (result?.success === true && settings?.paye?.name) {
        setPayeName(settings.paye.name);
      }
    } catch (error) {
      // fall back to the default "PAYE" label
    }
  };
  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const getDeductionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDeductionType();
      if (result?.success) {
        setDeductionType(result?.data?.deductions);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const getPensionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPensionType();
      if (result?.success) {
        setPensionType(result?.data);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const getLeviesType = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeviesType();
      if (result?.success) {
        setLeviesType(result?.data?.levies);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getASFringeType();
      if (result?.success) {
        setFringeData(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const SearchEmployee = async (text) => {
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) {
        setEmployeeData(result?.data?.employees);
        setLoading(false);

        // console.log(result,"result getemployee")
      } else {
        setLoading(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      setLoading(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleEmployeeReport = async (employee, cost, empId, format) => {
    const staffId = cost === "all" ? "" : empId;
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.handleEmployeeReport(employee, cost, staffId, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null; // Not JSON, must be file
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }

      const mimeType =
        format === "pdf"
          ? "application/pdf"
          : format === "excel"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "text/csv";

      const blob = result instanceof Blob ? result : new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePayslipReport = async (paymentMethod, department, start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const blob = await AuthService.handlePayslipReport(paymentMethod, department, start, end, format);
      const downloadError = await getBlobErrorMessage(blob);
      if (downloadError) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(downloadError, "error");
        return;
      }
      const dateStr = `${start}_${end}`.replace(/[^a-zA-Z0-9]/g, '_');
      const extension = format === 'pdf' ? 'pdf' : format === 'excel' ? 'xlsx' : 'csv';
      const filename = `PayslipReport_${dateStr}.${extension}`;

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
      LoaderHelper.loaderStatus(false);

    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      showAlert(error.message || 'Download failed', 'error');
    }
  };

  const handleEmpPayslipReport = async (email, start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleEmpPayslipReport(email, start, end, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null; // Not JSON, must be file
      }
      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePensionReport = async (start, end, pension, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handlePensionReport(start, end, pension, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null; // Not JSON, must be file
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleLeviesReport = async (email, start, end, levy, format, filters) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleLeviesReport(email, start, end, levy, format, filters);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null; // Not JSON, must be file
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleDeductionReport = async (deduction, start, end, department, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleDeductionReport(deduction, start, end, department, format);
      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null; // Not JSON, must be file
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleFringeReport = async (start, end, fringe, format, filters) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleFringeReport(start, end, fringe, format, filters);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleCreditReport = async (start, end, credit, format, filters) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleCreditReport(start, end, credit, format, filters);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleLoanReport = async (start, end, format, filters) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleLoanReport(start, end, format, filters);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePayeReport = async (start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handlePayeReport(start, end, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleGeneralizeTax = async (start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.handleGeneralizeTax(start, end, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }

      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleSdlReport = async (start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleSdlReport(start, end, format);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleUifReport = async (start, end, format) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleUifReport(start, end, format);
      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }

      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleAttendanceReport = async (start, end, includeAllEmployees, format, filters) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleAttendanceReport(start, end, includeAllEmployees, format, filters);

      let parsedResult;
      try {
        parsedResult = JSON.parse(await result.text());
      } catch {
        parsedResult = null;
      }

      if (parsedResult && parsedResult.success === false) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(parsedResult?.message || "An error occurred while generating the report.", "error");
        return;
      }
      const mimeType =
        format === "pdf" ? "application/pdf" : format === "excel" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv";
      const blob = new Blob([result], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `FileName.${format === "pdf" ? "pdf" : format === "excel" ? "xlsx" : "csv"}`);

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };

  const getReportMenu = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getReportMenu();
      if (result?.success) {
        setReportMenu(result?.data || []);
      }
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  return (
    <ReportsPage departmentData={departmentData} handleEmployee={SearchEmployee} loading={loading} employeeData={employeeData}
      handleEmployeeReport={handleEmployeeReport} handlePayslipReport={handlePayslipReport} handleEmpPayslipReport={handleEmpPayslipReport}
      handlePensionReport={handlePensionReport} handleLeviesReport={handleLeviesReport} handleDeductionReport={handleDeductionReport}
      deductionType={deductionType} leviesType={leviesType} pensionType={pensionType} handlePayeReport={handlePayeReport}
      handleSdlReport={handleSdlReport} handleUifReport={handleUifReport} handleFringeReport={handleFringeReport} handleCreditReport={handleCreditReport}
      handleLoanReport={handleLoanReport}
      fringeData={fringeData} handleAttendanceReport={handleAttendanceReport} empData={empData} creditsType={creditsType} handleGeneralizeTax={handleGeneralizeTax} reportMenu={reportMenu} payeName={payeName} />
  )

}

export default Reports;
